import { useLocation, useNavigate } from "react-router-dom";
import MaterialTypography from "../../../../components/MaterialTypography";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  IconButton,
  Popover,
  Stack,
  Typography,
} from "@mui/material";
import { BsFillPersonVcardFill } from "react-icons/bs";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialInput from "../../../../components/MaterialInput";
import { Delete, Info } from "@mui/icons-material";
import "../index.css";
import { useEffect, useState } from "react";
import MaterialButton from "../../../../components/MaterialButton";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import {
  allDeliveredQuery,
  createReturnMutation,
  getBySalesId,
  getReturnsDataById,
  getSalesorderLite,
} from "../graphQl";
import { useAuthData } from "../../../context/loginContext/LoginContextProvider";
import Swal from "sweetalert2";
import { useLoading } from "../../../../context/LodingContext";

const ReturnForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const formType = location?.state?.type;
  const rowId = location?.state?.rowId;
  const { userId } = useAuthData();
  const [allSalesOrdersData, setAllSalesOrdersData] = useState([]);
  const [inputDisable, setInputDisable] = useState(false);
  const [salesOrderOptions, setSalesOrderOptionns] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "customer-address-popover" : undefined;
  const [returnFormData, setReturnFormData] = useState({
    salesOrder: "",
    customerName: "",
    isOldSO: false,
    customerAddress: "",
  });

  const [products, setProducts] = useState([
    { productNameManual: "", returnQuantity: "", returnReason: "" },
  ]);

  //UseEffect to set Page type
  useEffect(() => {
    if (formType == "view") {
      setInputDisable(true);
    } else {
      setInputDisable(false);
    }
  }, [formType]);

  // Fetch SO Number, Customer name, Products
  useEffect(() => {
    const fetchAllData = async () => {
      setCirleLoading(true);
      try {
        const response = await request(BASEURL, allDeliveredQuery);
        const salesOrdersData = response.completedDeliveries?.data;
        const optionValue = salesOrdersData?.map((so) => ({
          label: so?.salesOrder?.soNumber,
          value: so?.salesOrder.id,
        }));
        const salesOrderOptions = [
          { label: "Old SO", value: "Old SO" },
          ...optionValue,
        ];

        setSalesOrderOptionns(salesOrderOptions);
        setAllSalesOrdersData(salesOrdersData);

        const allProducts = [];
        salesOrdersData.forEach((delivery) => {
          if (Array.isArray(delivery.deliveryProducts)) {
            delivery.deliveryProducts.forEach((product) => {
              allProducts.push({
                label: product.productName,
                value: product.productCode,
              });
            });
          }
        });
        setProductOptions(allProducts);
      } catch (error) {
        console.error("Error fetching Data", error);
      } finally {
        setCirleLoading(false);
      }
    };
    fetchAllData();
  }, []);

  //Fetch Return Data by ID
  useEffect(() => {
    if (!rowId) return;
    const fetchReturnsDataById = async () => {
      try {
        setCirleLoading(true);
        const response = await request(BASEURL, getReturnsDataById, {
          returnId: rowId,
        });
        const responseData = response.getReturnById.data?.[0];
        if (responseData) {
          // Set form data
          setReturnFormData((prev) => ({
            ...prev,
            customerName: responseData.customerName || "",
            customerNameStatus: responseData.customerName
              ? "success"
              : "unchecked",
            isOldSO: responseData.isOldSo || false,
            salesOrder: responseData.salesOrder
              ? {
                  label: responseData.salesOrder,
                  value: responseData.salesOrder,
                }
              : { label: "Old SO", value: "Old SO" },
            salesOrderStatus: "success",
          }));
          // Set product with  label and value if productName and productCode exists, else directly set productNameManual
          setProducts(
            (responseData.returnProducts || []).map((product) => ({
              productNameManual:
                product.productNameManual ||
                (product.product?.productName && product.product?.productCode
                  ? {
                      label: product.product.productName,
                      value: product.product.productCode,
                    }
                  : ""),
              returnQuantity: product.returnQuantity || "",
              returnReason: product.returnReason || "",
            }))
          );
        }
      } catch (error) {
        console.error("Error Fetching Data:", error);
        Swal.fire({
          position: "top",
          icon: "error",
          title: "Sorry! Network Issue",
          showConfirmButton: true,
        });
      } finally {
        setCirleLoading(false);
      }
    };
    fetchReturnsDataById();
  }, [rowId]);

  //Handle Submit API Function
  const handleSubmitReturn = async () => {
    setCirleLoading(true);
    try {
      const formattedProducts = products.map((p) => {
        if (returnFormData?.isOldSO) {
          return {
            productNameManual: p.productNameManual,
            returnQuantity: p.returnQuantity,
            returnReason: p.returnReason,
          };
        } else {
          return {
            productId: p.productNameManual?.value || p.productNameManual, // support both object/value
            productNameManual: null,
            returnQuantity: p.returnQuantity,
            returnReason: p.returnReason,
          };
        }
      });

      const values = {
        isOldSo: returnFormData?.isOldSO,
        salesOrder: returnFormData?.salesOrder?.value,
        userId: userId,
        customerName: returnFormData?.customerName,
        returnProducts: formattedProducts,
      };
      const response = await request(BASEURL, createReturnMutation, {
        input: values,
      });
      const successStatus = response.createReturns.success;
      const responseMessage = response.createReturns.message;
      if (successStatus) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: responseMessage,
          showConfirmButton: true,
        }).then(() => {
          navigate("/returns-management");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: responseMessage,
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error("Error Submitting Data: ", error);
      Swal.fire({
        position: "top",
        icon: "error",
        title: "Sorry! Network Issue",
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  //Handle add Product Button
  const handleAdd = () => {
    setProducts([
      ...products,
      { productNameManual: "", returnQuantity: "", returnReason: "" },
    ]);
  };

  //Handle Remove Product Button
  const handleRemove = (index) => {
    const updated = [...products];
    updated.splice(index, 1);
    setProducts(updated);
  };

  //Handle Change for SO Number and Customer Name
  const handleChange = async (event, selectEvent) => {
    let returnFormState = { ...returnFormData };

    if (event?.target === undefined && selectEvent) {
      // Handling MaterialSelect
      switch (selectEvent.name) {
        case "salesOrder": {
          const value = event?.value ?? "";
          const alphaNLenghthRegex = new RegExp("^(.{1,5000})$");

          returnFormState.salesOrder = event;
          returnFormState.salesOrderStatus = alphaNLenghthRegex.test(value)
            ? "success"
            : value === ""
            ? "unchecked"
            : "error";

          // Toggle isOldSO
          returnFormState.isOldSO = value === "Old SO";

          // If not "Old SO", set customerName from delivery
          if (value !== "Old SO") {
            returnFormState.customerName = "";
            returnFormState.customerNameStatus = "unchecked";
            try {
              const response = await request(BASEURL, getBySalesId, {
                id: Number(event?.value),
              });
              const value = response?.getSalesorder?.data[0];
              const success = response?.getSalesorder?.success;
              if (success) {
                returnFormState.customerName = value?.customer?.customerName;
                returnFormState.customerNameStatus = "success";

                const filteredProductOptions = value?.salesorderproductSet.map(
                  (product) => ({
                    label: product?.product?.productName,
                    value: product?.product?.productCode,
                  })
                );
                setProductOptions(filteredProductOptions);
              }
            } catch (error) {}
            const selectedOrder = allSalesOrdersData.find(
              (order) => order.salesOrder === value
            );

            if (selectedOrder?.customerAddress) {
              returnFormState.customerAddress = selectedOrder.customerAddress;
            }

            if (selectedOrder?.customerName) {
              returnFormState.customerName = selectedOrder.customerName;
              returnFormState.customerNameStatus = "success";
            }
            const selectedProducts = selectedOrder?.deliveryProducts ?? [];
          } else {
            returnFormState.customerName = "";
            returnFormState.customerNameStatus = "unchecked";
          }
          setProducts((prev) =>
            prev.map((p) => ({
              ...p,
              productNameManual: "",
              returnQuantity: "",
              returnReason: "",
            }))
          );
          break;
        }
      }
    } else if (event?.target) {
      // Handling MaterialInput
      const { name, value } = event.target;
      switch (name) {
        case "customerName": {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,50})$");
          returnFormState[name + "Status"] = alphaNLenghthRegex.test(
            value.trim()
          )
            ? "success"
            : value === ""
            ? "unchecked"
            : "error";
          break;
        }
      }
      returnFormState[name] = value;
    }

    setReturnFormData(returnFormState);
  };

  //Handle Change for Product Details as whole
  const handleProductChange = (event, index, fieldName) => {
    const updated = [...products];

    const value =
      event?.target?.value !== undefined
        ? event.target.value // for input
        : event; // for select

    updated[index][fieldName] = value;
    setProducts(updated);
  };

  //On click for Info Icon
  const handleInfoClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  //Close for Info icon
  const handleClose = () => {
    setAnchorEl(null);
  };

  //Submit Validation
  const checkAllFields = () => {
    let allowSubmit = false;
    const hasValidProduct = products.some(
      (p) =>
        p.productNameManual?.toString().trim() !== "" &&
        p.returnQuantity?.toString().trim() !== "" &&
        p.returnReason?.toString().trim() !== ""
    );
    if (
      returnFormData.salesOrderStatus === "success" &&
      returnFormData.customerNameStatus === "success" &&
      hasValidProduct
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType == "add"
                    ? "Add Returns Details"
                    : formType == "edit"
                    ? "Edit Returns Details"
                    : "View Returns Details"}
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <Stack
            direction="row"
            spacing={1}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <BsFillPersonVcardFill style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Return Information
            </MaterialTypography>
          </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 6, xs: 6, sm: 6 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    SO Number <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="salesOrder"
                  value={returnFormData.salesOrder}
                  onChange={handleChange}
                  options={salesOrderOptions}
                  success={returnFormData.salesOrderStatus === "success"}
                  error={returnFormData.salesOrderStatus === "error"}
                  isDisabled={inputDisable}
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 6, sm: 6 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialBox sx={{ display: "flex" }}>
                  <MaterialBox sx={{ width: "94%", display: "flex" }}>
                    <MaterialInput
                      name="customerName"
                      onChange={handleChange}
                      value={returnFormData.customerName}
                      success={returnFormData.customerNameStatus === "success"}
                      error={returnFormData.customerNameStatus === "error"}
                      disabled={inputDisable || !returnFormData.isOldSO}
                    />
                  </MaterialBox>

                  {!returnFormData.isOldSO && (
                    <MaterialBox ml={1} sx={{ width: "6%", display: "flex" }}>
                      <IconButton onClick={handleInfoClick}>
                        <Info />
                      </IconButton>

                      <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        PaperProps={{
                          sx: {
                            backgroundColor: "#acd4b4",
                            border: "1px solid #d3d3d3",
                            boxShadow: 3,
                            borderRadius: 1,
                            maxWidth: 200,
                            padding: 0.5,
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            p: 1,
                            fontSize: "13px",
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                          }}
                        >
                          Address: {returnFormData.customerAddress || "N/A"}
                        </Typography>
                      </Popover>
                    </MaterialBox>
                  )}
                </MaterialBox>
                {returnFormData.customerNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Customer name should be less than 50 characters{" "}
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
            <MaterialBox
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                width: "100%",
                paddingTop: "10px",
              }}
            >
              <button
                className="Add-Button"
                onClick={handleAdd}
                disabled={inputDisable}
              >
                +
              </button>
            </MaterialBox>
            {products.map((product, index) => (
              <>
                <MaterialBox mt={2} key={index}>
                  <div
                    style={{
                      border: "solid 1px black",
                      padding: "20px",
                      borderRadius: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid size={{ lg: 3, xs: 6, sm: 6 }}>
                        <MaterialBox>
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Product Name <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        {returnFormData.isOldSO ? (
                          <MaterialInput
                            name="productNameManual"
                            value={product.productNameManual}
                            onChange={(e) =>
                              handleProductChange(e, index, "productNameManual")
                            }
                            disabled={inputDisable}
                          />
                        ) : (
                          <MaterialSelect
                            name="productNameManual"
                            value={product.productNameManual}
                            options={productOptions}
                            onChange={(selected) =>
                              handleProductChange(
                                selected,
                                index,
                                "productNameManual"
                              )
                            }
                            isDisabled={inputDisable}
                            menuPlacement="top"
                          />
                        )}
                      </Grid>
                      <Grid size={{ lg: 3, xs: 6, sm: 6 }}>
                        <MaterialBox>
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Return Quantity{" "}
                            <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          name="returnQuantity"
                          type="number"
                          value={product.returnQuantity}
                          onChange={(e) =>
                            handleProductChange(e, index, "returnQuantity")
                          }
                          disabled={inputDisable}
                        />
                      </Grid>
                      <Grid size={{ lg: 5, xs: 10, sm: 10 }}>
                        <MaterialBox>
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Return Reason{" "}
                            <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          name="returnReason"
                          value={product.returnReason}
                          onChange={(e) =>
                            handleProductChange(e, index, "returnReason")
                          }
                          disabled={inputDisable}
                        />
                      </Grid>
                      <Grid>
                        {products.length > 1 && (
                          <button
                            className="Delete-Button"
                            style={{ marginTop: "25px" }}
                            onClick={() => handleRemove(index)}
                            disabled={inputDisable}
                          >
                            <Delete />
                          </button>
                        )}
                      </Grid>
                    </Grid>
                  </div>
                </MaterialBox>
              </>
            ))}
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              size="small"
              onClick={() => navigate("/returns-management")}
            >
              Cancel
            </MaterialButton>
            {formType != "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                size="small"
                disabled={!checkAllFields()}
                onClick={formType == "add" ? handleSubmitReturn : ""}
              >
                {formType == "add" ? "Submit" : "Update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default ReturnForm;
